import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppResponse, CargaDocumentosRequest, CargaDocumentosRequestAnticipo } from '../Entities';
import { InformeValidaciones } from '../Entities/informe-validaciones';
import { RequestAnexo } from '../Entities/RequestAnexo';

@Injectable({
  providedIn: 'root',
})
export class CargaDocumentosService {
  constructor(private http: HttpClient) { }

  public cargarFacturaEntradaMercancia(
    request: CargaDocumentosRequest
  ): Observable<any> {
    return this.http.post<any>(
      `${environment.url_carga_factura_cf}/v1/negocio_documentos/carga/factura`,
      request
    );
  }
  public cargarNotaCreditoEntradaMercancia(
    request: CargaDocumentosRequest
  ): Observable<any> {
    return this.http.post<any>(
      `${environment.url_carga_factura_cf}/v1/negocio_documentos/carga/notacredito`,
      request
    );
  }

  public obtenerVistaPreviaFactura(request_carga_factura: CargaDocumentosRequest): Observable<AppResponse<Array<any>>> {
    return this.http.post<any>(`${environment.url_carga_factura_cf}/v1/negocio_documentos/vista_previa/factura`, request_carga_factura);
  }

  public cargarAnticipoOC(request_anticipo: CargaDocumentosRequestAnticipo): Observable<AppResponse<Array<any>>> {
    return this.http.post<any>(`${environment.url_carga_factura_cf}/v1/negocio_documentos/carga/anticipo`, request_anticipo);
  }

  public getValidacionesFactura(identificador: string): Observable<AppResponse<InformeValidaciones>> {
    return this.http.get<AppResponse<InformeValidaciones>>(`${environment.url_carga_factura}/v1/negocio_documentos/consulta/GetValidaciones/${identificador}`);
  }

  public cargarAnexo(request: RequestAnexo): Observable<AppResponse<any>> {
    return this.http.post<any>(`${environment.url_carga_factura_cf}/v1/negocio_documentos/anexo`, request);
  }

  public getAnexos(id: any): Observable<AppResponse<Array<any>>> {
    return this.http.get<any>(`${environment.url_carga_factura_cf}/v1/negocio_documentos/anexo/${id}`);
  }

  public getUrlPdf(request?: string) {
    return this.http.get(request!, { responseType: 'text' });
  }

  public getUrlFile(request?: string): Observable<AppResponse<any>> {
    return this.http.get<any>(request!);
  }

}
